// extracted by mini-css-extract-plugin
export default {"headerTextComponent":"context_headerTextComponent__6Mml1"};